import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "message-toasts" }
const _hoisted_2 = ["data-type"]
const _hoisted_3 = { class: "icon-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "icon fastic-check",
  "data-color": "white"
}
const _hoisted_5 = {
  key: 1,
  class: "icon fastic-alert",
  "data-color": "white"
}
const _hoisted_6 = { class: "message" }
const _hoisted_7 = ["onClick"]

import { computed, onMounted } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastHub',
  setup(__props) {

const store = useStore();

const toasts = computed(() => store.getters["accountAreaToastStore/toasts"]);

onMounted(() => {
	(<any>store).subscribeAction((action: any, state: any) => {
		if (action.type === "accountAreaToastStore/onAddToast") {
			addToast(action.payload);
		}
	});
});

function addToast(toast: any) {
	if (toasts.value.length <= 1) {
		toast.id = new Date().valueOf();
		toasts.value.push(toast);
		store.commit("accountAreaToastStore/setToasts", toasts.value);

		setTimeout(() => {
			dismissToast(toast);
		}, 6 * 1000, toast);
	}
}

function dismissToast(toast: any) {
	for (let i = 0; i < toasts.value.length; i++) {
		if (toasts.value[i].id === toast.id) {
			toasts.value.splice(i, 1);
			store.commit("accountAreaToastStore/setToasts", toasts.value);
			break;
		}
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "toast",
        "data-type": toast.type?.toLowerCase(),
        key: index
      }, [
        _createElementVNode("div", _hoisted_3, [
          (toast.type === 'Success')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          (toast.type === 'Warning' || toast.type === 'Error')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(toast.message) + " ", 1),
          _createElementVNode("span", {
            onClick: ($event: any) => (dismissToast(toast)),
            class: "icon fastic-close"
          }, null, 8, _hoisted_7)
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})